// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.vertical-group.m-widget1 + .m-widget1[data-v-136de577] {\n  padding-top: 0;\n}\n.top-spacing[data-v-136de577] {\n  min-height: 2rem;\n}\n@media (max-width: 568px) {\n.m-widget1[data-v-136de577] {\n    padding: 1rem 1.5rem;\n}\n}\n.m-widget1 .m-widget1__item.no-spacing[data-v-136de577] {\n  padding: 0;\n}\n", ""]);
// Exports
module.exports = exports;
